document.addEventListener('DOMContentLoaded', function () {
  // Toggle menu open
  document.querySelector('.toggle-menu-mobile .site-header__link').addEventListener('click', function () {
    document.body.classList.add('js-drawer-open', 'js-drawer-open-left');
  });

  // Toggle menu close
  document.querySelector('.mobile-cross-button button').addEventListener('click', function () {
    document.body.classList.remove('js-drawer-open', 'js-drawer-open-left');
  });

  // Mini cart scroll toggle
  const miniCart = document.querySelector('.js-mini-cart');

  function toggleScroll() {
    document.body.style.overflow = miniCart.classList.contains('active') ? 'hidden' : '';
  }

  toggleScroll();

  const observer = new MutationObserver(toggleScroll);
  observer.observe(miniCart, { attributes: true, attributeFilter: ['class'] });

  // Update navigation link styles
  document.querySelectorAll('header .site-nav__link .site-nav__title').forEach(function (el) {
    if (el.textContent.trim() === "SALE" || el.textContent.trim() === "Sale") {
      el.style.color = '#C65428';
    }
    if (el.textContent.trim() === "Archive Sale") {
      el.style.color = '#C65428';
      el.style.fontWeight = '700';
    }
     if (el.textContent.trim() === "New Arrivals") {
      el.style.color = '#C65428';
      el.style.fontWeight = '500';
    }
  });

  document.querySelectorAll('.drawer__nav .drawer__nav-item .drawer__nav-link').forEach(function (el) {
    if (el.textContent.trim() === "SALE" || el.textContent.trim() === "Sale") {
      el.style.color = '#C65428';
    }
    if (el.textContent.trim() === "Archive Sale") {
      el.style.color = '#C65428';
      el.style.fontWeight = '700';
    }
     if (el.textContent.trim() === "New Arrivals") {
      el.style.color = '#C65428';
      el.style.fontWeight = '500';
    }
  });

  // Toggle drawer navigation level
  document.addEventListener('click', function (event) {
    if (event.target.classList.contains('dev_open_level0')) {
      const level0 = event.target.closest('.drawer__nav-item').querySelector('.dev_level0');
      if (level0) {
        if (level0.style.display === 'none' || level0.style.display === '') {
          level0.style.display = 'block';
          event.target.textContent = '-';
        } else {
          level0.style.display = 'none';
          event.target.textContent = '+';
        }
      }
    }
  });

  // Slider functionality (freebie + backpack upsell carousels)
  function initUpsellSlider(containerSelector, dotsSelector, dotClass) {
    const container = document.querySelector(containerSelector);
    if (!container) return;

    const dots = document.querySelectorAll(dotsSelector + ' .' + dotClass);
    let autoScrollInterval;
    let isUserScrolling = false;
    let isPaused = false;

    function updateActiveDot() {
      if (!dots.length) return;
      const index = Math.round(container.scrollLeft / container.clientWidth);
      dots.forEach((dot, i) => {
        dot.classList.toggle('active', i === index);
      });
    }

    function slideNext() {
      if (isUserScrolling || isPaused) return;

      const scrollAmount = container.clientWidth + 16; // +gap for spacing

      if (container.scrollLeft + scrollAmount >= container.scrollWidth) {
        container.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      }
    }

    // Start auto scroll
    autoScrollInterval = setInterval(slideNext, 5000);

    // Detect user scroll and pause auto scroll
    let scrollTimeout;
    container.addEventListener('scroll', () => {
      isUserScrolling = true;
      updateActiveDot();
      clearTimeout(scrollTimeout);
      clearInterval(autoScrollInterval);

      scrollTimeout = setTimeout(() => {
        isUserScrolling = false;
        if (!isPaused) {
          autoScrollInterval = setInterval(slideNext, 5000);
        }
      }, 3000);
    });

    // Pause auto scroll on hover
    container.addEventListener('mouseenter', () => {
      isPaused = true;
      clearInterval(autoScrollInterval);
    });

    // Resume auto scroll when mouse leaves
    container.addEventListener('mouseleave', () => {
      isPaused = false;
      if (!isUserScrolling) {
        autoScrollInterval = setInterval(slideNext, 5000);
      }
    });

    // Clicking a dot jumps to that slide
    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        container.scrollTo({ left: i * container.clientWidth, behavior: 'smooth' });
      });
    });
  }

  initUpsellSlider('.freebie-upsell-container', '.freebie-dots', 'freebie-dot');
  initUpsellSlider('.backpack-upsell-container', '.backpack-dots', 'backpack-dot');
});

